<template>
  <div class="container">
    <div>
      <div class="mwow-button-filled primary outside" @click="clickexport">
        导出
      </div>
      <!-- 批量修改下拉按钮 -->
      <div
        v-if="multipleSelection.length > 0"
        style="display: inline-block; margin-left: 20px"
      >
        <el-popover
          placement="bottom"
          width="70"
          trigger="click"
          :visible-arrow="false"
          popper-class="no-padding"
          :disabled="multipleSelection.length === 0"
        >
          <slot>
            <div class="muti-buttons">
              <teacher-edit :ori="multipleSelection" @change="handleSearch">
                <div class="btn">教务老师</div>
              </teacher-edit>
              <follow-staff-edit
                :ori="multipleSelection"
                @change="handleSearch"
              >
                <div class="btn">课程顾问</div>
              </follow-staff-edit>
            </div>
          </slot>
          <div slot="reference" class="mwow-button-filled primary">
            批量修改<i class="el-icon-arrow-down" style="margin-left: 8px"></i>
          </div>
        </el-popover>
      </div>
      <div v-else style="display: inline-block; margin-left: 20px">
        <div
          class="mwow-button-filled"
          style="
            background: #f5f7fa !important;
            border-color: #f5f7fa !important;
            color: #c2c3c4 !important;
          "
        >
          批量修改<i class="el-icon-arrow-down" style="margin-left: 8px"></i>
        </div>
      </div>
    </div>
    <div class="searchBox">
      <el-form size="mini" ref="form" :model="searchInfo" inline>
        <el-row>
          <el-col :span="8">
            <el-form-item label="学员搜索:" class="my-autocomplete">
              <el-input
                placeholder="学员姓名/手机号"
                v-model="searchInfo.key_word"
                @change="handleSearch"
                @clear="handleSearch"
                prefix-icon="el-icon-search"
                clearable
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性别:">
              <el-select
                v-model.number="searchInfo.sex"
                clearable
                @change="handleSearch"
                placeholder="请选择"
                class="drawer_onlychoose"
              >
                <el-option label="男" :value="1"></el-option>
                <el-option label="女" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="年龄分布:">
              <el-select
                v-model="searchInfo.age_stage"
                placeholder="请选择"
                clearable
                @change="handleSearch"
              >
                <el-option label="暂无年龄" :value="8"></el-option>
                <el-option label="X ≤ 3" :value="1"></el-option>
                <el-option label="3 < X ≤ 6" :value="2"></el-option>
                <el-option label="6 < X ≤ 9" :value="3"></el-option>
                <el-option label="9 < X ≤ 12" :value="4"></el-option>
                <el-option label="12 < X ≤ 15" :value="5"></el-option>
                <el-option label="15 < X ≤ 18" :value="6"></el-option>
                <el-option label="18 < X" :value="7"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="年龄筛选:">
              <div class="inputBox">
                <el-input
                  v-model.number="searchInfo.age_start"
                  type="number"
                  placeholder="开始年龄"
                  @change="handleSearch"
                ></el-input>
                <span>至</span>
                <el-input
                  v-model.number="searchInfo.age_end"
                  type="number"
                  placeholder="结束年龄"
                  @change="handleSearch"
                >
                </el-input>
                <span
                  class="el-icon-error clear-icon"
                  v-if="searchInfo.age_start && searchInfo.age_end"
                  @click="
                    () => {
                      searchInfo.age_start = '';
                      searchInfo.age_end = '';
                      handleSearch();
                    }
                  "
                ></span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="课程顾问:">
              <common-staff-pull-down
                :originId.sync="searchInfo.follow_staff_id"
                :defaultSelected.sync="searchInfo.follow_staff_list"
                :jobIds="[3]"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用户意向:" prop="intent">
              <el-select
                v-model="searchInfo.degree_of_interest"
                multiple
                filterable
                default-first-option
                placeholder="请选择"
                @change="handleSearch"
              >
                <el-option label="D" key="0" :value="0"> </el-option>
                <el-option label="C" key="1" :value="1"> </el-option>
                <el-option label="B" key="2" :value="2"> </el-option>
                <el-option label="A" key="3" :value="3"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="showFormSearch">
          <el-col :span="8">
            <el-form-item label="结业分类:" prop="completion_category_id">
              <el-select
                v-model.number="searchInfo.completion_category_id"
                clearable
                placeholder="请选择"
                @change="handleSearch"
              >
                <el-option label="距离远" :value="1"></el-option>
                <el-option label="不感兴趣" :value="2"></el-option>
                <el-option label="价格贵" :value="3"></el-option>
                <el-option label="时间不合适" :value="4"></el-option>
                <el-option label="艺考" :value="5"></el-option>
                <el-option label="学业忙/工作忙" :value="6"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结业时间:" prop="completion_date">
              <!-- <el-date-picker
                v-model="searchInfo.completion_date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                clearable
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </el-date-picker> -->
              <common-date-range-selector
                v-model="searchInfo.completion_date"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                clearable
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </common-date-range-selector>
              <!-- <div class="inputBox">
                <el-input
                  v-model="searchInfo.graduation_start"
                  placeholder="开始时间"
                  @change="handleSearch"
                ></el-input>
                <span>至</span>
                <el-input
                  v-model="searchInfo.graduation_end"
                  placeholder="结束时间"
                  @change="handleSearch"
                >
                </el-input>
              </div> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="首次入学时间:" prop="transform_date">
              <!-- <el-date-picker
                v-model="searchInfo.transform_date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                clearable
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </el-date-picker> -->
              <common-date-range-selector
                v-model="searchInfo.transform_date"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                clearable
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </common-date-range-selector>
              <!-- <div class="inputBox">
                <el-input
                  v-model="searchInfo.transform_start"
                  placeholder="开始时间"
                  @change="handleSearch"
                ></el-input>
                <span>至</span>
                <el-input
                  v-model="searchInfo.transform_end"
                  placeholder="结束时间"
                  @change="handleSearch"
                >
                </el-input>
              </div> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="最近入学时间:" prop="latest_transform_time">
              <!-- <el-date-picker
                v-model="searchInfo.latest_transform_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                clearable
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </el-date-picker> -->
              <common-date-range-selector
                v-model="searchInfo.latest_transform_time"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                clearable
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="time-line-switch">
          <div class="p4" @click="showFormSearch = !showFormSearch">
            {{ showFormSearch ? "收起" : "展开" }}
            <span
              :class="
                showFormSearch ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
              "
            ></span>
          </div>
        </div>
        <div class="time-line-switch resetting">
          <div class="p4" @click="resetSearch">
            重置
            <span class="el-icon-refresh-right"></span>
          </div>
        </div>
      </el-form>
    </div>
    <div>
      <el-table
        size="mini"
        v-horizontal-scroll
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
        stripe
        :data="tableData"
        @selection-change="handleSelectionChange"
        @sort-change="clickStort"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
          :selectable="(row) => row._mark !== 1"
        ></el-table-column>
        <el-table-column label="学员名字">
          <template slot-scope="scope">
            <div
              class="mwow-green studentName"
              @click="goStudentDetail(scope.row.student_id.toString())"
            >
              {{ scope.row.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="mobile">
          <template slot-scope="scope">
            {{ "+" + scope.row.area_code }} {{ scope.row.mobile || "-" }}
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
            >
              <p style="text-align: center">
                {{ `${scope.row.wechat_status === 0 ? "未" : "已"}绑定微信` }}
              </p>
              <i
                class="iconfont icon-wechat"
                slot="reference"
                :style="`margin-left:6px;font-size:15px;color:${
                  scope.row.wechat_status === 0 ? '#CCCCCC' : '#01D20B'
                }`"
              ></i>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="性别" prop="sex"> </el-table-column>
        <el-table-column label="年龄" prop="age"> </el-table-column>
        <el-table-column label="课程顾问">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.follow_staff == null
                  ? "-"
                  : scope.row.follow_staff.name
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="用户意向"
          prop="intent"
          align="center"
          width="80"
        >
          <template slot-scope="scope">
            {{ followLatentObj[scope.row.intent] || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="结业分类">
          <template slot-scope="scope">
            <div v-if="scope.row.completion_category_id === 1">距离远</div>
            <div v-if="scope.row.completion_category_id === 2">不感兴趣</div>
            <div v-if="scope.row.completion_category_id === 3">价格贵</div>
            <div v-if="scope.row.completion_category_id === 4">时间不合适</div>
            <div v-if="scope.row.completion_category_id === 5">艺考</div>
            <div v-if="scope.row.completion_category_id === 6">
              学业忙/工作忙
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="结业原因"
          width="270"
          class-name="historyStudentCon"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.completion_remark">
              <el-popover
                placement="top-start"
                title="结业原因"
                width="200"
                trigger="hover"
                :content="scope.row.completion_remark"
              >
                <span slot="reference">
                  {{ scope.row.completion_remark }}
                </span>
              </el-popover>
            </span>
            <span v-else> - </span>
          </template>
        </el-table-column>
        <el-table-column
          label="结业时间"
          prop="completion_time"
          sortable="custom"
          width="100"
          :sort-orders="['ascending', 'descending']"
        >
        </el-table-column>
        <el-table-column
          label="首次入学时间"
          prop="transform_time"
          sortable="custom"
          width="150"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            <div class="selfheader">
              <div>首次入学时间</div>
              <el-popover
                placement="top"
                popper-class="followuppopover"
                trigger="hover"
                width="133"
              >
                <p class="tipck">首次缴费变为在读学员的时间</p>
                <div class="question" slot="reference">
                  <div>?</div>
                </div>
              </el-popover>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="sortBox">
              {{ scope.row.transform_time }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="最近入学时间"
          prop="latest_transform_time"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot-scope="scope">
            <div class="sortBox">
              {{ scope.row.latest_transform_time }}
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <div class="operationBox">
              <div class="mwow-button success" @click="openRenew(scope.row)">
                续费
              </div>
              <div
                style="margin-left: 5px"
                class="mwow-button warning"
                @click="convertIntention(scope.row)"
              >
                转回意向
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      :style="{ float: 'right', padding: '17px' }"
    >
    </el-pagination>
  </div>
</template>
<script>
import {
  historyList,
  historyExport,
  studentHistoryToIntentApi,
} from "@/api/studentManage";
import { getFollowLatentApi } from "@/api/studentFollow";
import { exportLoop } from "@/utils/export";
import { dateFormat } from "@/utils/timeFormat";
import { PageModule } from "@/store/module/page";
import teacherEdit from "./teacherEdit.vue";
import followStaffEdit from "./followStaffEdit.vue";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import {
  staffList,
  getSelectClassList,
  getSelectCourseList,
  searchStudent,
} from "@/api/globalSearch";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

export default {
  name: "history",
  components: {
    teacherEdit,
    followStaffEdit,
    commonStaffPullDown,
    commonDateRangeSelector,
  },
  data() {
    return {
      searchInfo: {
        degree_of_interest: [],
        sort_type: "",
        sort_field: "",
        follow_staff_id: "",
        follow_staff_list: [],
      }, //搜索数据
      tableData: [], //列表数据
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      page: 1,
      staffName: "", //员工搜索名字
      teacherName: "", //教师搜索名字
      courseName: "", //课程名字
      studentName: "", //学员名字
      className: "",
      multipleSelection: [],
      followLatentObj: {},
      showFormSearch: false,
      // 未来时间应不可选
      effectiveDate: {
        disabledDate(date) {
          return date.getTime() > Date.now();
        },
      },
    };
  },

  created() {
    const _t = this;
    if (PageModule.latestRoute === "dashboard") {
      const params = this.$route.params;
      if (params.tab === "history") {
        if (params.completion_start_date && params.completion_end_date) {
          this.searchInfo.graduation_start = params.completion_start_date;
          this.searchInfo.graduation_end = params.completion_end_date;
        }
      }
    } else {
      const pageData = PageModule.pageInfo.history;
      if (pageData.page) {
        _t.page = pageData.page;
      }
      if (pageData.page_size) {
        _t.pageSize = pageData.page_size;
      }
      if (pageData.search_info) {
        _t.searchInfo = pageData.search_info;
      }
    }
    this.getList(
      {
        page: _t.page,
        page_size: _t.pageSize,
      },
      () => {}
    );
    getFollowLatentApi().then((res) => {
      const obj = {};
      res.data.list.map((item) => {
        obj[item.key] = item.value;
      });
      this.followLatentObj = obj;
    });
  },
  methods: {
    convertIntention(val) {
      this.$confirm(
        "确定要转回意向学员，此操作过程不能撤销，确定后将移动至意向学员列表，且学员的历史数据记录会保留，但将回到 “待分配” 阶段，确定要转回意向学员？",
        `转回意向 - ${val.name}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          studentHistoryToIntentApi({
            student_id: val.student_id,
          }).then((res) => {
            if (res.error_code === 0) {
              this.$message({
                message: "操作完成",
                type: "success",
              });
              this.$router.push({
                name: "latent",
              });
            }
          });
        })
        .catch(() => {});
    },
    // 去到学员详情
    goStudentDetail(sid) {
      this.cachePageInfo();
      this.$router.push({
        name: "studyDetails",
        query: {
          id: sid,
          from: "history",
        },
      });
    },
    resetSearch() {
      this.searchInfo = {
        degree_of_interest: [],
        sort_type: this.searchInfo.sort_type,
        sort_field: this.searchInfo.sort_field,
      };
      this.page = 1;
      this.pageSize = 10;
      this.getList(
        {
          page: this.page,
          page_size: this.pageSize,
        },
        () => {}
      );
    },
    // 导出开始
    clickexport(data) {
      const _t = this;
      if (_t.searchInfo.key_word) {
        data.key_word = _t.searchInfo.key_word;
      }
      if (_t.searchInfo.sex) {
        data.sex = _t.searchInfo.sex;
      }
      if (_t.searchInfo.follow_staff_id) {
        data.follow_staff_id = _t.searchInfo.follow_staff_id;
      }
      if (_t.searchInfo.degree_of_interest.length > 0) {
        data.intent_arr = _t.searchInfo.degree_of_interest;
      }
      if (_t.searchInfo.completion_category_id) {
        data.completion_category_id = _t.searchInfo.completion_category_id;
      }
      historyExport(data).then((res) => {
        if (res.error_code == 0) {
          exportLoop(res.data.task_id);
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    // 导出结束
    choosestatus() {
      const _t = this;
    },
    // 学员搜索~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~end
    // 通用搜索框
    getSelectrList(e) {
      const _t = this;
      _t.globalSearch("", e);
    },
    getglobalsearchdata(data, type) {
      if (type == "staff") {
        data.job_ids = [3];
        return staffList(data);
      } else if (type == "teacher") {
        return staffList(data);
      } else if (type == "class") {
        return getSelectClassList(data);
      } else if (type == "course") {
        return getSelectCourseList(data);
      } else if (type == "student") {
        data.status = [2];
        return searchStudent(data);
      }
    },
    async globalSearch(queryString, type) {
      const _t = this;
      let data = {
        page: 1,
        page_size: 100,
      };
      let restaurants = {};
      if (queryString) {
        data = {
          page: 1,
          page_size: 10,
        };
        if (type == "class") {
          data.name = queryString;
        } else if (type == "course") {
          data.title = queryString;
        } else if (type == "student") {
          data.key_word = queryString;
        } else {
          data.key_word = queryString;
        }
      }
      restaurants = await _t.getglobalsearchdata(data, type);
      const list = restaurants.data.list;
      if (type == "staff") {
        _t.staffName = list;
      } else if (type == "teacher") {
        _t.teacherName = list;
      } else if (type == "class") {
        _t.className = list;
      } else if (type == "course") {
        _t.courseName = list;
      } else if (type == "student") {
        _t.studentName = list;
      }
    },
    // 通用搜索框结束
    getList(data, cb) {
      const _t = this;
      if (_t.searchInfo.key_word) {
        data.key_word = _t.searchInfo.key_word;
      }
      if (_t.searchInfo.sex) {
        data.sex = _t.searchInfo.sex;
      }
      if (_t.searchInfo.follow_staff_id) {
        data.follow_staff_id = _t.searchInfo.follow_staff_id;
      }
      if (
        _t.searchInfo.completion_date &&
        _t.searchInfo.completion_date.length === 2
      ) {
        data.completion_start_time = dateFormat(
          "YYYY-mm-dd",
          _t.searchInfo.completion_date[0]
        );
        data.completion_end_time = dateFormat(
          "YYYY-mm-dd",
          _t.searchInfo.completion_date[1]
        );
      }
      if (
        _t.searchInfo.transform_date &&
        _t.searchInfo.transform_date.length === 2
      ) {
        data.transform_start_time = dateFormat(
          "YYYY-mm-dd",
          _t.searchInfo.transform_date[0]
        );
        data.transform_end_time = dateFormat(
          "YYYY-mm-dd",
          _t.searchInfo.transform_date[1]
        );
      }
      if (
        _t.searchInfo.latest_transform_time &&
        _t.searchInfo.latest_transform_time.length === 2
      ) {
        data.latest_transform_start_time = dateFormat(
          "YYYY-mm-dd",
          _t.searchInfo.latest_transform_time[0]
        );
        data.latest_transform_end_time = dateFormat(
          "YYYY-mm-dd",
          _t.searchInfo.latest_transform_time[1]
        );
      }
      // if (_t.searchInfo.graduation_start && _t.searchInfo.graduation_end) {
      //   data.completion_start_time = String(_t.searchInfo.graduation_start);
      //   data.completion_end_time = String(_t.searchInfo.graduation_end);
      // }
      // if (_t.searchInfo.transform_end) {
      //   data.transform_end_time = String(_t.searchInfo.transform_end);
      // }
      // if (_t.searchInfo.transform_start) {
      //   data.transform_start_time = String(_t.searchInfo.transform_start);
      // }
      if (_t.searchInfo.sort_type) {
        data.sort_type = _t.searchInfo.sort_type;
      }
      if (_t.searchInfo.sort_field) {
        data.sort_field = _t.searchInfo.sort_field;
      }
      if (_t.searchInfo.degree_of_interest.length > 0) {
        data.intent_arr = _t.searchInfo.degree_of_interest;
      }
      if (_t.searchInfo.age_start) {
        data.age_start = _t.searchInfo.age_start;
      }
      if (_t.searchInfo.age_end) {
        data.age_end = _t.searchInfo.age_end;
      }
      if (_t.searchInfo.age_stage > 0) {
        data.age_stage = _t.searchInfo.age_stage;
      }
      if (_t.searchInfo.completion_category_id) {
        data.completion_category_id = _t.searchInfo.completion_category_id;
      }
      if (
        _t.searchInfo.age_start &&
        parseInt(_t.searchInfo.age_start) !==
          parseFloat(_t.searchInfo.age_start)
      ) {
        _t.$message({
          message: "开始年龄不能为小数",
          type: "error",
        });
        return;
      }
      if (
        _t.searchInfo.age_end &&
        parseInt(_t.searchInfo.age_end) !== parseFloat(_t.searchInfo.age_end)
      ) {
        _t.$message({
          message: "结束年龄不能为小数",
          type: "error",
        });
        return;
      }
      historyList(data).then((res) => {
        if (res.error_code == 0) {
          if (res.data.list != null) {
            const today = new Date().getTime();
            res.data.list.map((item) => {
              item.sex = item.sex == 1 ? "男" : item.sex == 2 ? "女" : "-";
              item.transform_time =
                item.transform_time != ""
                  ? dateFormat(
                      "YYYY-mm-dd",
                      new Date(Number(item.transform_time + "000"))
                    )
                  : "-";
              item.completion_time =
                item.completion_time != ""
                  ? dateFormat(
                      "YYYY-mm-dd",
                      new Date(Number(item.completion_time + "000"))
                    )
                  : "-";
              item.latest_transform_time =
                item.latest_transform_time != ""
                  ? dateFormat(
                      "YYYY-mm-dd",
                      new Date(Number(item.latest_transform_time + "000"))
                    )
                  : "-";
              if (item.age === 0) {
                if (item.birthday !== 0) {
                  const severalMonths = today - item.birthday * 1000;
                  item.age = new Date(severalMonths).getMonth() + "个月";
                } else {
                  item.age = "-";
                }
              } else {
                item.age = item.age + "岁";
              }
            });
          }
          _t.tableData = res.data.list;
          _t.total = res.data.total;
          _t.page = res.data.page;
          if (cb) {
            cb();
          }
        }
      });
    },
    openRenew(e) {
      this.cachePageInfo();
      const _t = this;
      _t.$confirm(
        "历史学员在完成缴费后，状态将自动转为在读，并移动至在读学员列表。确定要缴费？",
        `缴费 - ${e.name}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          iconClass: "mwow-icon-error",
        }
      )
        .then(() => {
          _t.$router.push({
            name: "buyCourseConfirm",
            query: { id: e.student_id, course_id: e.course_id },
          });
        })
        .catch(() => {});
    },
    cachePageInfo() {
      PageModule.SET_PAGE_INFO({
        name: "history",
        key: "page",
        value: this.page,
      });
      PageModule.SET_PAGE_INFO({
        name: "history",
        key: "page_size",
        value: this.pageSize,
      });
      PageModule.SET_PAGE_INFO({
        name: "history",
        key: "search_info",
        value: this.searchInfo,
      });
    },
    handlePagerChange(e) {
      this.cachePageInfo();
      this.getList(
        {
          page: e,
          page_size: this.pageSize,
        },
        () => {}
      );
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.cachePageInfo();
      this.getList(
        {
          page: 1,
          page_size: e,
        },
        () => {}
      );
    },
    handleSelectionChange(arr) {
      this.multipleSelection = arr;
    },

    handleSearch() {
      const _t = this;
      this.getList(
        {
          page: 1,
          page_size: _t.pageSize,
        },
        () => {}
      );
    },
    // 排序
    clickStort(e) {
      this.searchInfo.sort_field = e.prop;
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.getList(
        {
          page: 1,
          page_size: this.pageSize,
        },
        () => {}
      );
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  padding: 0 12px 12px 12px;
}
/deep/ .searchBox {
  margin-top: 12px;
  .inputBox {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    line-height: 30px;
    height: 30px !important;
    .el-input {
      width: 165px;
    }
    .el-input__inner {
      border: none !important;
    }
    span {
      margin: 0 10px 0 0;
    }
  }
}
.my-autocomplete {
  /deep/ li {
    line-height: normal;
    padding: 7px;
    height: auto;
    .autocompletename {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .autocompleteaddr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .autocompleteaddr {
      color: #ddd;
    }
  }
}
.el-form .el-form-item__label {
  text-align: left !important;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 18px !important;
  margin-right: 80px !important;
  line-height: 30px !important;
}
.explain {
  font-size: 12px;
  color: #5c5d5e;
  line-height: 18px;
}
.explain.color {
  color: #07d1aa;
}
.suspensionBox:nth-of-type(1) {
  margin-top: 20px;
}
.suspensionBox {
  .el-form-item {
    margin-bottom: 18px !important;
  }
  .el-input {
    width: 220px !important;
  }
}
.green {
  color: #07d1aa;
}
.el-range-editor--small.el-input__inner {
  height: 30px !important;
}
.studentName {
  cursor: pointer;
}
.muti-buttons {
  .btn {
    padding-left: 10px;
    line-height: 28px;
    font-size: 12px;
    color: #5c5d5e;
    cursor: pointer;
    &:hover {
      background: #f5f7fa;
      color: #07d1aa;
    }
  }
  .dialog-wrap {
    display: block;
  }
}
/deep/.el-table {
  th {
    &.is-sortable {
      .cell {
        display: flex !important;
        align-items: center;
      }
      .caret-wrapper {
        position: relative;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        }
      }
    }
  }
}
/deep/ .el-form {
  .el-form-item {
    width: 100%;
    display: flex;
    .el-form-item__label {
      min-width: 86px;
      text-align: right;
    }
    .el-form-item__content {
      margin-right: 58px;
      width: 100%;
      flex: 1;
      .inputBox {
        display: flex;
        position: relative;
        &:hover {
          .clear-icon {
            display: block;
          }
        }
        .clear-icon {
          position: absolute;
          top: 8px;
          right: 0;
          font-size: 14px;
          color: #d8d8d8;
          cursor: pointer;
          display: none;
        }
        .el-input {
          width: auto;
          text-align: center;
        }
      }
    }
    .el-select {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
  }
}
.time-line-switch {
  position: absolute;
  top: 41px;
  right: 0;
  .p4 {
    padding: 8px;
    font-size: 12px;
    cursor: pointer;
    color: #5c5d5e;
    span {
      font-size: 14px;
      color: #c0c4cc;
      margin-left: 4px;
    }
  }
}
.resetting {
  top: 90px !important;
  right: 0 !important;
}
.selfheader {
  display: flex;
  align-items: center;
}
.question {
  width: 15px;
  height: 15px;
  opacity: 1;
  background: #bebfc0;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  margin-left: 5px;
}
/deep/ .historyStudentCon {
  .cell {
    width: 23em;
    overflow: hidden; /*超出部分隐藏*/
    white-space: nowrap; /*禁止换行*/
    text-overflow: ellipsis;
  }
}
</style>
